export default "__VITE_ASSET__B0THH$st__"